function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoMilvus(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    d: "M5.98 7.198a7.447 7.447 0 0110.564 0c2.922 2.93 2.922 7.682 0 10.608a7.45 7.45 0 01-10.565-.005l-4.38-4.79a.725.725 0 010-1.023zm9.432 1.408a5.47 5.47 0 00-7.76 0l-3.116 3.517a.536.536 0 000 .754l3.12 3.521a5.47 5.47 0 007.761 0 5.524 5.524 0 00-.005-7.792zm-3.852.139c2.032 0 3.678 1.684 3.678 3.762 0 2.078-1.646 3.762-3.678 3.762-2.031 0-3.678-1.684-3.678-3.762 0-2.078 1.647-3.762 3.678-3.762zm8.668 1.1c-.127-.13-.339-.01-.296.168a11.595 11.595 0 010 4.987c-.038.178.173.293.296.168l2.1-2.147a.74.74 0 000-1.028l-2.1-2.148z",
    fill: "#0A1633",
    fillRule: "evenodd"
  }));
}

SvgLogoMilvus.clsName = 'icon-uc-social__logo-milvus';
SvgLogoMilvus.remarkName = 'unknown';
export default SvgLogoMilvus;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoMilvus.js
// module id = 2249
// module chunks = 17 18